import { useEffect } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import HomePage from "@/app/page";
import ProgrammePage from "@/app/programme/page";
import AboutPage from "@/app/about/page";
import ResourcesPage from "@/app/resources/page";
import NoticePage from "@/app/notice/page";
import CourseHomePage from "@/app/course/page";
import StartPage from "@/app/course/start/page";
import RegulatoryPage from "@/app/course/regulatory/page";
import WeekPage from "@/app/course/week/[slug]/page";
import LabPage from "@/app/course/lab/[slug]/page";
import { LabMaterialPage, WeekMaterialPage } from "@/app/course/material/page";
import { CourseShell } from "@/src/components/CourseShell";
import { SiteFooter, SiteHeader } from "@/src/components/SiteChrome";
import { StudentGate } from "@/src/components/StudentGate";
import { MetaManager } from "@/src/MetaManager";
import config from "@/site.config.json";

function RedirectHandler() {
  const navigate = useNavigate();
  useEffect(() => {
    const redirectPath = sessionStorage.getItem("redirectPath");
    if (redirectPath) {
      sessionStorage.removeItem("redirectPath");
      navigate(redirectPath, { replace: true });
    }
  }, [navigate]);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function StudentArea() {
  return <StudentGate><CourseShell><Outlet /></CourseShell></StudentGate>;
}

function NotFoundPage() {
  return <main id="main-content" className="student-page-hero shell"><p className="eyebrow">Page not found</p><h1>This route has moved</h1><p>Use the main navigation to continue, or return to the home page.</p><a className="button primary" href="/">Return home</a></main>;
}

export default function App() {
  const basename = config.base_path === "/" ? undefined : config.base_path.replace(/\/$/, "");
  return (
    <BrowserRouter basename={basename}>
      <RedirectHandler />
      <ScrollToTop />
      <MetaManager />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/programme" element={<ProgrammePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/notice" element={<NoticePage />} />
        <Route path="/course" element={<StudentArea />}>
          <Route index element={<CourseHomePage />} />
          <Route path="start" element={<StartPage />} />
          <Route path="regulatory" element={<RegulatoryPage />} />
          <Route path="week/:slug" element={<WeekPage />} />
          <Route path="week/:slug/material/:docId" element={<WeekMaterialPage />} />
          <Route path="lab/:slug" element={<LabPage />} />
          <Route path="lab/:slug/material/:docId" element={<LabMaterialPage />} />
        </Route>
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  );
}
